import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { applySeo } from "@/lib/seo";

export default function SeoManager() {
    const { pathname } = useLocation();
    useEffect(() => {
        applySeo(pathname.replace(/\/+$/, "") || "/");
    }, [pathname]);
    return null;
}
